/* GT menu (desktop): open panels on hover or click, one at a time; close on Escape, outside click or focus leaving. */
if (!customElements.get('gt-nav')) {
  customElements.define('gt-nav', class GtNav extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('details.gt-nav__dd'));
      this.hover = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.timer = null;
      const warm = () => this.querySelectorAll('.gt-nav__panel img[loading="lazy"]').forEach((i) => { i.loading = 'eager'; });
      this.addEventListener('pointerenter', warm, { once: true });
      this.addEventListener('focusin', warm, { once: true });
      this.items.forEach((d) => {
        const s = d.querySelector('summary');
        s.setAttribute('aria-expanded', 'false');
        d.addEventListener('toggle', () => {
          s.setAttribute('aria-expanded', d.open ? 'true' : 'false');
          if (d.open) { this.setTop(); this.items.forEach((o) => { if (o !== d) o.open = false; }); }
        });
        const li = d.closest('li');
        s.addEventListener('click', (e) => {
          if (!this.hover.matches) return;
          e.preventDefault();
          clearTimeout(this.timer);
          if (d.open && d.gtByHover) { d.gtByHover = false; return; }
          d.gtByHover = false;
          d.open = !d.open;
        });
        li.addEventListener('mouseenter', () => {
          if (!this.hover.matches) return;
          clearTimeout(this.timer);
          this.timer = setTimeout(() => { if (!d.open) { d.gtByHover = true; d.open = true; } }, 90);
        });
        li.addEventListener('mouseleave', () => { if (!this.hover.matches) return; clearTimeout(this.timer); this.timer = setTimeout(() => { d.open = false; }, 160); });
        d.addEventListener('focusout', (e) => { if (!d.contains(e.relatedTarget)) d.open = false; });
      });
      this.onKey = (e) => {
        if (e.key !== 'Escape') return;
        const open = this.items.find((d) => d.open);
        if (open) { open.open = false; open.querySelector('summary').focus(); }
      };
      this.onClick = (e) => { if (!this.contains(e.target)) this.items.forEach((d) => (d.open = false)); };
      document.addEventListener('keyup', this.onKey);
      document.addEventListener('click', this.onClick);
    }
    disconnectedCallback() {
      document.removeEventListener('keyup', this.onKey);
      document.removeEventListener('click', this.onClick);
    }
    setTop() {
      const w = this.closest('.header-wrapper');
      if (w) document.documentElement.style.setProperty('--gt-nav-top', Math.round(w.getBoundingClientRect().bottom) + 'px');
    }
  });
}
